export const state = {
  formationProfessionnelle: undefined,
  formationProfessionnelles: [],
  communes: [],
  sousFormationProfessionnelle: undefined,
  sousFormationProfessionnelles: []
}